import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "foquz-icon-input-radio",
  "use": "foquz-icon-input-radio-usage",
  "viewBox": "0 0 19 19",
  "content": "<symbol viewBox=\"0 0 19 19\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"foquz-icon-input-radio\"><path d=\"M13 7A6 6 0 111 7a6 6 0 0112 0z\" stroke=\"currentColor\" stroke-width=\"2\" /><path d=\"M10 7a3 3 0 11-6 0 3 3 0 016 0zm-1.221 8.824a9.04 9.04 0 01-2.547.144 7 7 0 109.735-9.735 9.11 9.11 0 01-.143 2.546 5 5 0 01-7.045 7.045z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol